const settings = {
    label: "Forms & Contact",
    name: "contact",
    file: "site/data/contact.yaml",
    i18n: true,
    fields: [
        {
          label: "Address",
          name: "address",
          widget: "markdown",
            required: false,
            i18n: true,
        },
        {label: "Nature of your enquiries", name: "enquiries", summary:"{{enquiry}}", widget: "list", i18n: true, field: {
                label: "Enquiry", name: "enquiry", widget: "string" , i18n: true,
            }},
        { label: "Privacy Link",
            name: "privacy",
            widget: "relation",
            multiple: false,
            required: false,
            collection: "legals",
            search_fields: [ "title" ],
            value_field: "{{slug}}",
            display_fields: [ "title" ],
            i18n: true,
        }
    ]
}

export default settings;
